var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0 8 0 8 9 0 9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mobile---Event-Details",
    transform: "translate(-34.000000, -3586.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(35.000000, 3587.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    stroke: "#979797"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    cx: 9,
    cy: 9,
    r: 9
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(5.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.14180198,1.0734 L3.14180198,1.0734 C3.14189885,0.5718 3.53566542,0.1651 4.02174676,0.1651 C4.50773124,0.1651 4.90149781,0.5718 4.90149781,1.0734 L4.90149781,1.5687 L3.14180198,1.5687 L3.14180198,1.0734 Z M7.36028673,4.7891 L6.34104641,4.7891 L6.34104641,3.1871 C5.61085885,3.034 5.06142613,2.3677 5.06142613,1.5687 L5.06142613,1.0734 C5.06142613,0.4806 4.59588071,0 4.02174676,0 C3.44732222,0 2.98187366,0.4806 2.98187366,1.0734 L2.98187366,1.5687 C2.98187366,2.3675 2.43215034,3.0339 1.70215651,3.187 L1.70215651,4.7891 L0.639713272,4.7891 C0.286243598,4.7891 0,5.0848 0,5.4496 C0,5.8143 0.286340465,6.11 0.639713272,6.11 L0.799738458,6.11 C1.06476806,6.11 1.27962028,6.3319 1.27962028,6.6054 C1.27962028,6.879 1.06476806,7.1009 0.799738458,7.1009 L0.799738458,7.2659 C1.15311126,7.2659 1.43945173,6.9702 1.43945173,6.6054 C1.43945173,6.2406 1.15311126,5.9449 0.799738458,5.9449 L0.639713272,5.9449 C0.374683667,5.9449 0.15983145,5.723 0.15983145,5.4496 C0.15983145,5.1759 0.374683667,4.9541 0.639713272,4.9541 L1.70215651,4.9541 L1.70215651,9 L6.34114328,9 L6.34114328,4.9541 L7.36028673,4.9541 C7.62531633,4.9541 7.84007168,5.1759 7.84007168,5.4496 C7.84007168,5.723 7.62531633,5.9449 7.36028673,5.9449 L7.20035841,5.9449 C6.84688874,5.9449 6.5604514,6.2406 6.5604514,6.6054 C6.5604514,6.9702 6.84688874,7.2659 7.20035841,7.2659 L7.20035841,7.1009 C6.9353288,7.1009 6.72037972,6.879 6.72037972,6.6054 C6.72037972,6.3319 6.9353288,6.11 7.20035841,6.11 L7.36028673,6.11 C7.7137564,6.11 8,5.8143 8,5.4496 C8,5.0848 7.7137564,4.7891 7.36028673,4.7891 L7.36028673,4.7891 Z",
    id: "Fill-1",
    fill: "#979797",
    mask: "url(#mask-2)"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffing);
export default __webpack_public_path__ + "static/media/Staffing.13be56e077c307f331b89a02d7d6d911.svg";
export { ForwardRef as ReactComponent };